import React, { useState } from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import "./GlossaryItem.scss";
import Modal from "../Modal/modal";

const GlossaryItem = ({ title, description }) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <span
        onClick={() => setShow(true)}
        className="glossaryItemTrigger"
      >
        {parse(title)}
      </span>
      <Modal
        showModal={show}
        setShowModal={setShow}
        onClose={() => setShow(false)}
        title={title}
      >
        {parse(description)}
      </Modal>
    </>
  );
};

GlossaryItem.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default GlossaryItem;
